import React, { useState } from 'react';
import { Shield, Lock, CreditCard, Zap, CheckCircle2, Circle, Star } from 'lucide-react';
import { Button } from '../ui/Button';
import { Countdown } from '../ui/Countdown';
import { trackPixelEvent } from '../analytics/fbpixel';
const CHECKOUT_URLS = {
  profesional: 'https://profelisto.com.ar/checkouts/cn/hWNDA9n0P3WLVEfL94YTaEOA/es-ar?_r=AQABPj71mZri-LTXd3TlvrqV_z5qjdlSxo0R8CWMaR-LuuA',
  elite: 'https://profelisto.com.ar/checkouts/cn/hWNDA9nDRfjEiT2i92I36qIM/es-ar?_r=AQABYEhqZp2WVr9cFAD85YsW_x-UinJgUihosM2hHXp0Sbw'
} as const;
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'profesional' | 'elite'>('elite');
  return <section id="precio" className="py-20 bg-cream-50" data-id="element-157">
      <div className="max-w-5xl mx-auto px-4" data-id="element-158">
        {/* Timer Header */}
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 uppercase tracking-wider mb-4" data-id="element-160">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>
          <Countdown data-id="element-161" />
          <p className="text-wine-700 font-semibold animate-pulse" data-id="element-162">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* Pricing Panel */}
        <div className="max-w-2xl mx-auto bg-white rounded-[2rem] shadow-xl p-6 md:p-10 mb-20 border border-cream-100" data-id="element-163">
          <div className="text-center mb-8" data-id="element-164">
            <h3 className="font-serif text-3xl font-bold text-gray-900 mb-2" data-id="element-165">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500 font-medium" data-id="element-166">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-167">
            {/* Standard Pack Row */}
            <div onClick={() => setSelectedPack('profesional')} className={`relative flex items-center p-5 md:p-6 rounded-2xl border-2 cursor-pointer transition-all duration-200 ${selectedPack === 'profesional' ? 'border-wine-600 bg-wine-50/30' : 'border-cream-200 hover:border-cream-300 bg-white'}`} data-id="element-168">
              <div className="flex-shrink-0 mr-4" data-id="element-169">
                {selectedPack === 'profesional' ? <CheckCircle2 className="w-6 h-6 text-wine-600 fill-wine-100" data-id="element-170" /> : <Circle className="w-6 h-6 text-gray-300" data-id="element-171" />}
              </div>

              <div className="flex-1" data-id="element-172">
                <div className="flex items-center gap-2 mb-1" data-id="element-173">
                  <span className="text-xl" data-id="element-174">📘</span>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 leading-tight" data-id="element-175">
                    PACK PROFESIONAL
                  </h4>
                </div>
                <p className="text-gray-500 text-sm md:text-base" data-id="element-176">
                  12 Tomos + 6 Bonus
                </p>
              </div>

              <div className="text-right ml-4" data-id="element-177">
                <p className="text-gray-400 line-through text-sm md:text-base mb-0.5" data-id="element-178">
                  $29.990
                </p>
                <p className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-179">
                  $18.990
                </p>
              </div>
            </div>

            {/* Elite Pack Row */}
            <div onClick={() => setSelectedPack('elite')} className={`relative flex items-center p-5 md:p-6 rounded-2xl border-2 cursor-pointer transition-all duration-200 ${selectedPack === 'elite' ? 'border-wine-600 bg-wine-50/50 shadow-sm' : 'border-cream-200 hover:border-cream-300 bg-white'}`} data-id="element-180">
              <div className="flex-shrink-0 mr-4" data-id="element-181">
                {selectedPack === 'elite' ? <CheckCircle2 className="w-6 h-6 text-wine-600 fill-wine-100" data-id="element-182" /> : <Circle className="w-6 h-6 text-gray-300" data-id="element-183" />}
              </div>

              <div className="flex-1" data-id="element-184">
                <div className="flex items-center gap-2 mb-2" data-id="element-185">
                  <span className="text-xl" data-id="element-186">🏆</span>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 leading-tight" data-id="element-187">
                    MEGAPACK ELITE
                  </h4>
                </div>

                <div className="flex flex-col items-start gap-1.5 mb-2" data-id="element-188">
                  <span className="inline-flex items-center gap-1 bg-gold-400 text-gold-900 text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-md uppercase tracking-wide" data-id="element-189">
                    <Star className="w-3 h-3 fill-gold-900" data-id="element-190" /> MÁS ELEGIDO
                  </span>
                  <span className="inline-flex bg-wine-100 text-wine-800 text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-md uppercase tracking-wide" data-id="element-191">
                    AHORRÁS $10.000
                  </span>
                </div>

                <p className="text-gray-500 text-sm md:text-base leading-snug" data-id="element-192">
                  12 Tomos + 6 Bonus + 2 EBOOKS ELITE
                </p>
              </div>

              <div className="text-right ml-4 self-start md:self-center mt-8 md:mt-0" data-id="element-193">
                <p className="text-gray-400 line-through text-sm md:text-base mb-0.5" data-id="element-194">
                  $49.990
                </p>
                <p className="text-2xl md:text-3xl font-bold text-wine-700" data-id="element-195">
                  $27.990
                </p>
              </div>
            </div>
          </div>

          <Button href={CHECKOUT_URLS[selectedPack]} variant="primary" size="xl" className="w-full shadow-wine-700/30 text-lg md:text-xl py-5 rounded-2xl" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: selectedPack === 'elite' ? 'MEGAPACK ELITE' : 'PACK PROFESIONAL',
          value: selectedPack === 'elite' ? 27990 : 18990,
          currency: 'ARS'
        })} data-id="element-196">
            {selectedPack === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ELITE →' : 'SÍ, QUIERO EL PACK PROFESIONAL →'}
          </Button>

          <p className="text-center text-sm text-gray-400 mt-6 italic" data-id="element-197">
            La opción más elegida por profesoras de danza infantil argentinas
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-600 font-medium mb-20" data-id="element-198">
          <span className="flex items-center gap-2" data-id="element-199">
            <Lock className="w-4 h-4 text-gold-500" data-id="element-200" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-201">
            <Zap className="w-4 h-4 text-gold-500" data-id="element-202" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-203">
            <Shield className="w-4 h-4 text-gold-500" data-id="element-204" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-205">
            <CreditCard className="w-4 h-4 text-gold-500" data-id="element-206" /> Tarjeta ·
            Transferencia
          </span>
        </div>

        {/* Elite Features */}
        <div className="bg-cream-50 rounded-3xl p-8 md:p-12 mb-20 border border-cream-200" data-id="element-207">
          <div className="text-center mb-10" data-id="element-208">
            <h3 className="font-serif text-3xl font-bold text-gray-900 mb-4" data-id="element-209">
              ¿Qué agrega el Megapack Elite?
            </h3>
            <p className="text-lg text-wine-700 font-medium" data-id="element-210">
              Por solo $9.000 más, tenés el año entero resuelto de principio a
              fin.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-211">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-cream-100" data-id="element-212">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-213">
                <span className="text-2xl" data-id="element-214">🗺️</span> Elite 1 — El Mapa de Ruta
                Anual
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-215">
                El cronograma exacto de 40 semanas. Te dice qué Tomo abrir cada
                lunes, qué materiales llevar y qué ejercicio usar como base de
                la coreografía de muestra desde agosto. No improvisás ni un solo
                lunes del año.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-cream-100" data-id="element-216">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-217">
                <span className="text-2xl" data-id="element-218">🎭</span> Elite 2 — Muestras Sin Caos
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-219">
                El sistema para armar la coreografía de fin de año en 4 semanas
                sin gritos. Guía de vestuarios low cost · high impact, el script
                completo para hablar al micrófono y el plan de contingencia para
                cuando algo sale mal. Para que duermas tranquila la noche antes
                del show.
              </p>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="max-w-4xl mx-auto" data-id="element-220">
          <h3 className="font-serif text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-221">
            ¿Cuánto cuesta NO tenerlo?
          </h3>

          <div className="bg-white rounded-2xl shadow-lg border border-cream-200 overflow-hidden mb-10" data-id="element-222">
            <div className="grid grid-cols-2 bg-cream-50 border-b border-cream-200" data-id="element-223">
              <div className="p-4 md:p-6 text-center font-bold text-gray-500" data-id="element-224">
                Sin DANZA INFANTIL 360
              </div>
              <div className="p-4 md:p-6 text-center font-bold text-wine-700 bg-wine-50/50" data-id="element-225">
                Con DANZA INFANTIL 360
              </div>
            </div>

            {[['Horas planificando desde cero cada domingo', '7 minutos. Todo listo.'], ['Ejercicios improvisados sin progresión', '+120 ejercicios graficados por nivel y edad'], ['Grupos sin sistema claro', 'Estructura clara para Ciclos A, B y C'], ['Padres que preguntan "¿qué aprendió mi hijo?"', 'Ficha de progreso lista para mostrar'], ['Pánico en octubre sin saber qué bailan', 'Coreografía de muestra lista desde agosto'], ['Gritos en los ensayos de noviembre', 'Sistema de 4 semanas sin estrés'], ['Sensación de improvisar siempre', 'Entrás a clase con todo resuelto']].map((row, idx) => <div key={idx} className="grid grid-cols-2 border-b border-cream-100 last:border-0" data-id="element-226">
                <div className="p-4 md:p-6 text-gray-600 text-sm md:text-base flex items-center" data-id="element-227">
                  <span className="text-wine-400 mr-3 flex-shrink-0" data-id="element-228">❌</span>{' '}
                  {row[0]}
                </div>
                <div className="p-4 md:p-6 text-gray-900 font-medium text-sm md:text-base bg-wine-50/30 flex items-center" data-id="element-229">
                  <span className="text-gold-500 mr-3 flex-shrink-0" data-id="element-230">✅</span>{' '}
                  {row[1]}
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-231">
            <p className="text-xl text-gray-800 font-medium mb-8" data-id="element-232">
              El domingo podés improvisar o tener el año entero resuelto. Vos
              decidís.
            </p>
            <Button href="#precio" variant="primary" size="xl" className="shadow-wine-700/30" data-id="element-233">
              Asegurá tu año entero ahora →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}